module.exports = __webpack_public_path__ + "img/sixpackcarrier94.6cc12c4c.jpg";